import React from 'react';
import { StyledWeekDaysListWrapper, StyledWeekDaysHeaderItem } from './Styleds.js';

export const CalendarWeekDays = React.memo(() => (
  <span role="rowgroup">
    <StyledWeekDaysListWrapper
      role="row"
      cols={['2.4615rem', '2.4615rem', '2.4615rem', '2.4615rem', '2.4615rem', '2.4615rem', '2.4615rem']}
      rows={['1.6923rem']}
      py="xxxs"
      px="6px"
      justifyContent="space-between"
      alignItems="center"
      isHeader
    >
      <StyledWeekDaysHeaderItem role="columnheader" aria-colindex={1}>
        sun
      </StyledWeekDaysHeaderItem>
      <StyledWeekDaysHeaderItem role="columnheader" aria-colindex={2}>
        mon
      </StyledWeekDaysHeaderItem>
      <StyledWeekDaysHeaderItem role="columnheader" aria-colindex={3}>
        tue
      </StyledWeekDaysHeaderItem>
      <StyledWeekDaysHeaderItem role="columnheader" aria-colindex={4}>
        wed
      </StyledWeekDaysHeaderItem>
      <StyledWeekDaysHeaderItem role="columnheader" aria-colindex={5}>
        thu
      </StyledWeekDaysHeaderItem>
      <StyledWeekDaysHeaderItem role="columnheader" aria-colindex={6}>
        fri
      </StyledWeekDaysHeaderItem>
      <StyledWeekDaysHeaderItem role="columnheader" aria-colindex={7}>
        sat
      </StyledWeekDaysHeaderItem>
    </StyledWeekDaysListWrapper>
  </span>
));
